import { isNativeCapacitorApp } from "@/integrations/clients/carAuction/nativeAuth";

/** Native: dim behind sheets. Web: default dialog/sheet overlay. */
export const nativeOverlayZ = "z-[200]";

/** Native: bottom sheet / dialog surface. */
export const nativeSheetZ = "z-[201]";

/** Web: sheet/dialog overlay (Radix portaled). Above MobileBiddingBar (95). */
export const webOverlayZ = "z-[100]";

/** Web: sheet/dialog surface — same layer as overlay; DOM order stacks above overlay. */
export const webSheetZ = "z-[100]";

/** Web: portaled selects, popovers, dropdowns — above För dig sheet (211) and default sheets (100). */
export const webFloatingZ = "z-[220]";

/**
 * Portaled selects, popovers, dropdowns — must sit above native sheets (201).
 */
/** Full-screen media viewer above native sheets (news zoom, video, gallery). */
export const nativeMediaViewerZ = "z-[270]";

/** Web: fullscreen gallery above För dig sheet (211) and floating UI (220). */
export const webMediaViewerZ = "z-[280]";

/** Above nested sheets (231) and video overlay (260). */
export function overlayZClass(isNative: boolean): string {
  return isNative ? nativeOverlayZ : webOverlayZ;
}

export function sheetSurfaceZClass(isNative: boolean): string {
  return isNative ? nativeSheetZ : webSheetZ;
}

export function floatingContentZClass(webZ = webFloatingZ): string {
  return isNativeCapacitorApp() ? "z-[265]" : webZ;
}

/** Portaled fullscreen image viewer (CarImageGallery, tire lightbox, etc.). */
export function mediaViewerZClass(): string {
  return isNativeCapacitorApp() ? nativeMediaViewerZ : webMediaViewerZ;
}
